import TicketCreate from './create'
import Ticket from './ticket'
import TicketOverview from './overview'
module.exports = {
  TicketCreate,
  Ticket,
  TicketOverview
}



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/middlewares/ticket/index.js